"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const client = require("../../../../../src/api/client/lib-core-agent-api");
const _interopDefault = (e) => e && e.__esModule ? e : { default: e };
const client__default = /* @__PURE__ */ _interopDefault(client);
async function createAgentRequest(data, options = {}) {
  const res = await client__default.default({ method: "post", url: `/private/v1/registration-request`, data, ...options });
  return res.data;
}
exports.createAgentRequest = createAgentRequest;
